import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  const principles = ['Easy to understand', 'Easy to access', 'Transparent', 'Stress-free'];
  return <Section id="about" bg="white" data-id="element-5">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-6">
        <div data-id="element-7">
          <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-8">
            About Us
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-6" data-id="element-9">
            Who We Are
          </h3>
          <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-10">
            De Rien Cash Loan is a financial services start-up operating in
            Botswana, created to offer convenient and easy access to loans for
            individuals and businesses.
          </p>
          <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-11">
            We help our clients meet personal and business financial obligations
            through a variety of tailored loan products including New Loans,
            Top-Up Loans, Debt Consolidation, and more.
          </p>

          <div className="bg-offwhite p-6 rounded-xl border border-gold/20 mb-8" data-id="element-12">
            <h4 className="font-bold text-navy mb-4" data-id="element-13">
              We believe loan products should be:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-14">
              {principles.map(item => <div key={item} className="flex items-center" data-id="element-15">
                  <CheckCircle2 className="h-5 w-5 text-gold mr-2" data-id="element-16" />
                  <span className="text-gray-700 font-medium" data-id="element-17">{item}</span>
                </div>)}
            </div>
          </div>

          <p className="text-navy font-medium italic border-l-4 border-gold pl-4" data-id="element-18">
            At De Rien, we deliver "Get Real Finance Value" through ethics,
            expertise, and faith-driven service excellence.
          </p>
        </div>

        <div className="relative" data-id="element-19">
          <div className="relative h-[520px]" data-id="element-20">
            <img src="https://cdn.magicpatterns.com/uploads/6aSY6zfxkwW2i7xw9MemQ1/abt2.png" alt="De Rien Cash Loan advisor with client" className="rounded-lg shadow-lg w-4/5 h-72 object-cover absolute top-0 left-0 z-10" data-id="element-21" />
            <img src="https://cdn.magicpatterns.com/uploads/ikHzVGs1TUir6m4yKvweX4/abt_1.png" alt="De Rien Cash Loan team" className="rounded-lg shadow-xl w-4/5 h-72 object-cover absolute bottom-0 right-0 z-20 border-4 border-white" data-id="element-22" />
          </div>
        </div>
      </div>
    </Section>;
}